var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert(".text-danger[data-v-0f297db8] {\n  color: red;\n  font-size: 0.85rem;\n}\n.not-allowed[data-v-0f297db8] {\n  cursor: not-allowed;\n}")
;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = require("babel-runtime/helpers/slicedToArray");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _values = require("babel-runtime/core-js/object/values");

var _values2 = _interopRequireDefault(_values);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "CardDetails",
  props: ["submitting", "clear_form"],
  data: function data() {
    return {
      can_pay: false,
      realCVV: "",
      cardjswrapper: null,
      cardDetails: {
        cardNumber: "",
        expiryDate: "",
        cvv: "",
        firstName: "",
        lastName: "",
        email: ""
      },
      errors: {
        cardNumber: "",
        expiryDate: "",
        cvv: "",
        firstName: "",
        lastName: "",
        email: ""
      }
    };
  },
  mounted: function mounted() {
    this.mount_card_js();
  },

  watch: {
    errors: {
      handler: function handler() {
        this.can_pay = (0, _values2.default)(this.errors).every(function (err) {
          return err === "";
        });
      },

      deep: true
    },
    clear_form: function clear_form(newVal) {
      if (newVal === true) {
        this.clearForm();
      }
    }
  },
  computed: {
    maskedCVV: function maskedCVV() {
      return "*".repeat(this.realCVV.length);
    }
  },
  methods: {
    handleCVVInput: function handleCVVInput(e) {
      var input = e.target.value;

      var lastLength = this.realCVV.length;
      var currentLength = input.length;

      if (currentLength > lastLength) {
        var newChar = e.data;
        if (/\d/.test(newChar) && this.realCVV.length < 4) {
          this.realCVV += newChar;
        }
      } else {
        this.realCVV = this.realCVV.slice(0, -1);
      }

      this.cardDetails.cvv = this.realCVV;

      this.validateCVV();
    },
    mount_card_js: function mount_card_js() {
      $("#cardjswrapper").append('<div id="jswrapper" class="card-wrapper"></div>');

      this.setCard();
    },
    setCard: function setCard() {
      if (document.getElementById("frmCard")) {
        this.cardjswrapper = new Card({
          form: "#frmCard",
          container: ".card-wrapper",

          formSelectors: {
            numberInput: "input#CardNoCS",
            expiryInput: "input#expiryCS",
            cvcInput: "input#CVVCS",
            nameInput: "input#nameCS" },

          width: "350px",
          formatting: true,
          messages: {
            validDate: "Valid\nThru",
            monthYear: "month-year" },

          placeholders: {
            CardNo: "•••• •••• •••• ••••",
            name: "",
            expiry: ""
          },

          masks: {},

          debug: false });
      }
    },
    removeCardJsWrapper: function removeCardJsWrapper() {
      document.getElementById("jswrapper").style.display = "none";
    },
    validateCardNumber: function validateCardNumber() {
      var raw = this.cardDetails.cardNumber.replace(/\D/g, "");
      var limited = raw.substring(0, 20);
      var formatted = limited.replace(/(\d{4})(?=\d)/g, "$1 ");
      this.cardDetails.cardNumber = formatted;

      if (!limited) {
        this.errors.cardNumber = "Card number is required";
      } else if (limited.length < 13 || limited.length > 20) {
        this.errors.cardNumber = "Invalid card number length";
      } else if (!this.isValidLuhn(limited)) {
        this.errors.cardNumber = "Invalid card number";
      } else {
        this.errors.cardNumber = "";
      }
    },
    isValidLuhn: function isValidLuhn(cardNumber) {
      var sum = 0;
      var isEven = false;
      for (var i = cardNumber.length - 1; i >= 0; i--) {
        var digit = parseInt(cardNumber.charAt(i));
        if (isEven) {
          digit *= 2;
          if (digit > 9) digit -= 9;
        }
        sum += digit;
        isEven = !isEven;
      }
      return sum % 10 === 0;
    },
    validateExpiryDate: function validateExpiryDate() {
      var value = this.cardDetails.expiryDate.replace(/[^\d]/g, "");

      if (value.length >= 2) {
        value = value.substring(0, 2) + "/" + value.substring(2, 6);
      }

      this.cardDetails.expiryDate = value.substring(0, 7);

      var pattern = /^(0[1-9]|1[0-2])\/\d{4}$/;

      if (!this.cardDetails.expiryDate) {
        this.errors.expiryDate = "Expiry date is required";
      } else if (!pattern.test(this.cardDetails.expiryDate)) {
        this.errors.expiryDate = "Use format MM/YYYY";
      } else {
        var _cardDetails$expiryDa = this.cardDetails.expiryDate.split("/"),
            _cardDetails$expiryDa2 = (0, _slicedToArray3.default)(_cardDetails$expiryDa, 2),
            month = _cardDetails$expiryDa2[0],
            year = _cardDetails$expiryDa2[1];

        var exp = new Date(year, month - 1, 1);
        var now = new Date();

        exp.setMonth(exp.getMonth() + 1);
        exp.setDate(0);

        if (exp < now) {
          this.errors.expiryDate = "Card has expired";
        } else {
          this.errors.expiryDate = "";
        }
      }
    },
    validateCVV: function validateCVV() {
      var pattern = /^\d{3,4}$/;
      if (!this.cardDetails.cvv) {
        this.errors.cvv = "CVV is required";
      } else if (!pattern.test(this.cardDetails.cvv)) {
        this.errors.cvv = "Invalid CVV";
      } else {
        this.errors.cvv = "";
      }
    },
    validateFirstName: function validateFirstName() {
      this.errors.firstName = this.cardDetails.firstName ? "" : "First name is required";
    },
    validateLastName: function validateLastName() {
      this.errors.lastName = this.cardDetails.lastName ? "" : "Last name is required";
    },
    validateEmail: function validateEmail() {
      var pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!this.cardDetails.email) {
        this.errors.email = "Email is required";
      } else if (!pattern.test(this.cardDetails.email)) {
        this.errors.email = "Invalid email";
      } else {
        this.errors.email = "";
      }
    },
    validateField: function validateField(field) {
      switch (field) {
        case "cardNumber":
          this.validateCardNumber();
          break;
        case "expiryDate":
          this.validateExpiryDate();
          break;
        case "cvv":
          this.validateCVV();
          break;
        case "firstName":
          this.validateFirstName();
          break;
        case "lastName":
          this.validateLastName();
          break;
        case "email":
          this.validateEmail();
          break;
      }
    },
    clearForm: function clearForm() {
      $("#frmCard").trigger("reset");
      this.cardDetails = {
        cardNumber: "",
        expiryDate: "",
        cvv: "",
        firstName: "",
        lastName: "",
        email: ""
      };
      this.errors = {
        cardNumber: "",
        expiryDate: "",
        cvv: "",
        firstName: "",
        lastName: "",
        email: ""
      };
      this.can_pay = false;
    },
    validateForm: function validateForm() {
      this.validateCardNumber();
      this.validateExpiryDate();
      this.validateCVV();
      this.validateFirstName();
      this.validateLastName();
      this.validateEmail();
      return (0, _values2.default)(this.errors).every(function (err) {
        return err === "";
      });
    },
    handleSubmit: async function handleSubmit() {
      if (this.validateForm()) {
        if (this.cardDetails.cardNumber) {
          this.cardDetails.cardNumber = this.cardDetails.cardNumber.replace(/\s+/g, "");
        }
        this.submitting = true;
        try {
          this.$emit("collectedCardDetails", this.cardDetails);
        } finally {
          this.submitting = false;
        }
      }
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{attrs:{"id":"frmCard"}},[_c('div',{staticClass:"col-12",attrs:{"id":"cardjswrapper"}}),_vm._v(" "),_c('div',{staticClass:"card-body",attrs:{"id":"cardDetailsForm"}},[_c('div',{staticClass:"form-row",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"col-12 col-md-6"},[_c('label',[_vm._v("First Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.cardDetails.firstName),expression:"cardDetails.firstName",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","id":"nameCS","placeholder":"First name on card","required":""},domProps:{"value":(_vm.cardDetails.firstName)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.cardDetails, "firstName", $event.target.value.trim())},function($event){return _vm.validateField('firstName')}],"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),(_vm.errors.firstName)?_c('p',{staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.errors.firstName)+"\n        ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6"},[_c('label',[_vm._v("Last Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.cardDetails.lastName),expression:"cardDetails.lastName",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Surname on card","required":""},domProps:{"value":(_vm.cardDetails.lastName)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.cardDetails, "lastName", $event.target.value.trim())},function($event){return _vm.validateField('lastName')}],"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),(_vm.errors.lastName)?_c('p',{staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.errors.lastName)+"\n        ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-row",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"col-12 col-md-6"},[_c('label',[_vm._v("Card Number")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cardDetails.cardNumber),expression:"cardDetails.cardNumber"}],staticClass:"form-control",attrs:{"type":"text","id":"CardNoCS","placeholder":"1234 1234 1234 1234","maxlength":"23","required":""},domProps:{"value":(_vm.cardDetails.cardNumber)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.cardDetails, "cardNumber", $event.target.value)},function($event){return _vm.validateField('cardNumber')}]}}),_vm._v(" "),(_vm.errors.cardNumber)?_c('p',{staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.errors.cardNumber)+"\n        ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6"},[_c('label',[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.cardDetails.email),expression:"cardDetails.email",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"email","placeholder":"johndoe@email.cc","required":""},domProps:{"value":(_vm.cardDetails.email)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.cardDetails, "email", $event.target.value.trim())},function($event){return _vm.validateField('email')}],"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),(_vm.errors.email)?_c('p',{staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.errors.email)+"\n        ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-row",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"col-12 col-md-6"},[_c('label',[_vm._v("Valid Through")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cardDetails.expiryDate),expression:"cardDetails.expiryDate"}],staticClass:"form-control",attrs:{"placeholder":"MM/YYYY","type":"text","id":"expiryCS","maxlength":"7","required":""},domProps:{"value":(_vm.cardDetails.expiryDate)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.cardDetails, "expiryDate", $event.target.value)},function($event){return _vm.validateField('expiryDate')}]}}),_vm._v(" "),(_vm.errors.expiryDate)?_c('p',{staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.errors.expiryDate)+"\n        ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6"},[_c('label',[_vm._v("Card Code (CVC)")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","id":"CVVCS","placeholder":"CVC","maxlength":"4","required":""},domProps:{"value":_vm.maskedCVV},on:{"input":_vm.handleCVVInput}}),_vm._v(" "),(_vm.errors.cvv)?_c('p',{staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.errors.cvv)+"\n        ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"card-footer d-flex justify-content-end align-items-center"},[_c('a',{staticClass:"btn btn-link text-dark px-5",attrs:{"href":"#"},on:{"click":function($event){return _vm.window.location.reload()}}},[_vm._v("Cancel")]),_vm._v(" "),(!_vm.submitting)?_c('button',{staticClass:"btn btn-primary",attrs:{"disabled":!_vm.can_pay,"type":"button"},on:{"click":_vm.handleSubmit}},[_vm._v("\n        Pay\n      ")]):_vm._e(),_vm._v(" "),(_vm.submitting)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":""}},[_c('span',{staticClass:"spinner-border spinner-border-sm",attrs:{"role":"status","aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"visually-hidden"},[_vm._v("Please wait...")])]):_vm._e()])])])}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-0f297db8"
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  module.hot.dispose(__vueify_style_dispose__)
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0f297db8", __vue__options__)
  } else {
    hotAPI.reload("data-v-0f297db8", __vue__options__)
  }
})()}